import plur from "plur";

/**
 * "N noun(s)" - the count-with-pluralized-noun phrase repeated across the
 * cart summary surfaces (drawer header, badge, sticky bar, summary stats).
 * Wraps `plur` so a call site can't skip the pluralization guard the way
 * `CartBadge` once did (a 1-item cart read "1 items"). Preserves whatever
 * casing the caller passes for `noun` - this centralizes the mechanism, not
 * the wording, so each surface's existing copy is unchanged.
 */
export function pluralCount(count: number, noun: string): string {
  return `${count} ${plur(noun, count)}`;
}
